'use strict'

_loadedUrls = {}

module.exports =

  load: (url, cb) ->
    return if _loadedUrls[url]

    _loadedUrls[url] = true

    scriptTag = document.createElement('script')
    scriptTag.type = 'text/javascript'
    scriptTag.async = true
    scriptTag.src = url
    scriptTag.onload = cb
    document.getElementsByTagName('head')[0].appendChild(scriptTag)
